import React, {useEffect} from "react";
import * as Validator from "../../../../utils/Validator";
import {handleApiException} from "../../../../services/HttpService";
import {useHttpSortById} from "../../../../utils/usePreformattedHttp";
import EACrudDialog from "../../../EACrudDialog";

function TeilentsorgungsraumDialog({
                                       open,
                                       onClose,
                                       teilentsorgungsraum,
                                       onSaveTeilentsorgungsraum,
                                       schema = {
                                           verwaltungseinheit: Validator.requiredObject({}),
                                       },
                                   }) {
    const [verwaltungseinheitenLoader, refetchVerwaltungseinheiten] = useHttpSortById("/verwaltungseinheit/", {
        manual: true,
    });

    useEffect(() => {
        //Die Verwaltungseinheiten werden nur einmalig geladen, nachdem der Dialog das erste mal geöffnet wurde
        if (teilentsorgungsraum && !verwaltungseinheitenLoader.loading && !verwaltungseinheitenLoader.data) {
            refetchVerwaltungseinheiten().catch((e) =>
                handleApiException(e, "Error loading Verwaltungseinheiten for Teilentsorgungsraueme")
            );
        }
    }, [teilentsorgungsraum, verwaltungseinheitenLoader, refetchVerwaltungseinheiten]);

    return (
        <EACrudDialog
            open={open}
            onClose={onClose}
            title={"Entsorgungsraum hinzufügen"}
            submitTitle={"Übernehmen"}
            schema={schema}
            obj={teilentsorgungsraum}
            onSaveobj={onSaveTeilentsorgungsraum}
            buildContent={(formFactory) => {
                return (
                    <div style={{width: "35em"}}>
                        {formFactory.renderAutocomplete(
                            "verwaltungseinheit",
                            "verwaltungseinheit",
                            "Verwaltungseinheit",
                            verwaltungseinheitenLoader.data,
                            null,
                            "id",
                            verwaltungseinheitenLoader.loading,
                            false,
                            false,
                            {
                                getOptionLabel: (o) => o.gemeindeNr + " " + o.gemeindeBezeichnung + " " + (o.vGemeindeNr ? o.vGemeindeNr : ""),
                                placeholder: "Gemeinde-Nr. Gemeinde-Bezeichnung Verbandsgemeinde-Nr.",
                                style: {gridColumn: "1 / 3"},
                            }
                        )}
                    </div>
                );
            }}
        />
    );
}

export default TeilentsorgungsraumDialog;
